import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=ecdbe5ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecdbe5ca"]])

export default __exports__